import React from 'react';
import { Workflow } from '../../../types/workflow';

const ACTION_COLOR: Record<string, { bg: string; color: string }> = {
  'version.deploy':     { bg: '#E0F2FE', color: '#075985' },
  'prompt.edit':        { bg: '#EEF2FF', color: '#4338ca' },
  'approval':           { bg: '#E9F6F6', color: '#0F6E56' },
  'manual_intervention':{ bg: '#FEF3C7', color: '#92400e' },
  'draft.approve':      { bg: '#E0F2FE', color: '#075985' },
};

export function AuditTab({ workflow }: { workflow: Workflow }) {
  return (
    <section className="bg-white border border-trim rounded-xl overflow-hidden">
      <div className="px-5 py-3 border-b border-trim flex items-center justify-between">
        <h3 className="text-sm font-semibold text-ink">Audit trail</h3>
        <span className="text-xs text-muted">{workflow.audit.length} events</span>
      </div>
      <ul>
        {workflow.audit.map(e => {
          const cls = ACTION_COLOR[e.action] || { bg: '#F5F7FA', color: '#595A60' };
          return (
            <li key={e.id} className="px-5 py-3 border-b border-wash last:border-0 flex items-start gap-3 text-sm">
              <span className="font-mono text-xs text-muted w-44 flex-shrink-0">{new Date(e.ts).toLocaleString()}</span>
              <span className="px-2 py-0.5 rounded-full text-xs font-medium flex-shrink-0" style={{ background: cls.bg, color: cls.color }}>
                {e.action}
              </span>
              <div className="min-w-0">
                <div className="text-ink">
                  <span className="text-copy">{e.actor}</span> → <span className="font-mono text-xs">{e.target}</span>
                </div>
                <div className="text-xs text-muted mt-0.5">{e.details}</div>
              </div>
              <span className="ml-auto font-mono text-[10px] text-muted">{e.id}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
